/* eslint-disable import/prefer-default-export */

import { ApolloLink, HttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import { logLinkErrors } from './utils'

/**
 * Apollo http link to be used in next api routes
 */
const apiHttpLink = new HttpLink({
  uri: `${process.env.NEXT_PUBLIC_API_HOST}/graphql`,
})

/**
 * Apollo error link to be used in next api routes
 */
const apiErrorLink = onError((error) => {
  logLinkErrors(error)
})

/**
 * Creates apollo link to be used in next api routes
 */
export const createApiApolloLink = () => {
  return ApolloLink.from([apiHttpLink, apiErrorLink])
}
